import styled from 'styled-components';

export const Page = styled.div`
    min-height: 100vh;
    width: 100%;
    color: #ffffff;

    * {
        box-sizing: border-box;
    }
`;

export const GradientWrap = styled.div`
    height: 100vh;
    position: fixed;
    top: 0;
    width: 100vw;
    z-index: -500;
`;

export const HeaderWrap = styled.div`
    padding: 48px 48px 0;
    width: 100%;

    @media (max-width: 768px) {
        padding: 24px 24px 0;
    }
`;

export const Main = styled.main`
    display: flex;
    flex-direction: column;
    gap: 20px;
    margin: 0 auto;
    max-width: 1280px;
    padding: 56px 48px ${({ $editing }) => ($editing ? '168px' : '64px')};
    width: 100%;

    @media (max-width: 768px) {
        padding: 32px 20px ${({ $editing }) => ($editing ? '200px' : '48px')};
    }
`;

export const Lead = styled.p`
    color: rgba(255, 255, 255, 0.72);
    font-size: 15px;
    font-weight: 500;
    line-height: 1.5;
    margin: -8px 0 0;
    max-width: 62ch;
`;

export const Drop = styled.label`
    align-items: center;
    background: rgba(255, 255, 255, 0.12);
    border: 1px dashed rgba(255, 255, 255, 0.35);
    border-radius: 16px;
    cursor: pointer;
    display: flex;
    flex-direction: column;
    gap: 4px;
    justify-content: center;
    padding: 22px 16px;
    text-align: center;
    transition: background 0.15s ease, border-color 0.15s ease;

    &:hover,
    &.over {
        background: rgba(255, 255, 255, 0.2);
        border-color: rgba(255, 255, 255, 0.7);
    }

    svg {
        color: #ffffff;
        height: 30px;
        margin-bottom: 4px;
        width: 40px;
    }
`;

export const DropTitle = styled.span`
    font-size: 15px;
    font-weight: 600;
`;

export const DropOr = styled.span`
    color: rgba(255, 255, 255, 0.6);
    font-size: 12px;
    font-weight: 500;
`;

export const Toolbar = styled.div`
    align-items: end;
    backdrop-filter: blur(100px);
    background: rgba(255, 255, 255, 0.1);
    border: 1px solid rgba(255, 255, 255, 0.2);
    border-radius: 16px;
    display: flex;
    flex-wrap: wrap;
    gap: 14px 22px;
    padding: 14px;
`;

export const Field = styled.label`
    display: flex;
    flex-direction: column;
    gap: 6px;
    min-width: 0;
`;

export const FieldLabel = styled.span`
    color: rgba(255, 255, 255, 0.62);
    font-size: 11px;
    font-weight: 600;
    letter-spacing: 0.08em;
    text-transform: uppercase;
`;

export const RangeRow = styled.span`
    align-items: center;
    display: flex;
    gap: 8px;

    input[type='range'] {
        accent-color: #ffffff;
        width: 150px;
    }
`;

export const Value = styled.span`
    color: #ffffff;
    font-size: 12px;
    font-variant-numeric: tabular-nums;
    font-weight: 500;
    min-width: 3.2em;
`;

export const TextInput = styled.input`
    background: rgba(255, 255, 255, 0.1);
    border: 1px solid rgba(255, 255, 255, 0.28);
    border-radius: 4px;
    color: #ffffff;
    font-family: 'Inter', sans-serif;
    font-size: 14px;
    font-weight: 500;
    height: 40px;
    outline: none;
    padding: 0 10px;
    width: 160px;

    &:focus {
        border-color: rgba(255, 255, 255, 0.6);
    }
`;

export const FormatSelect = styled.select`
    height: 40px;
    min-width: 148px;
    width: auto;
`;

export const Bench = styled.div`
    display: grid;
    gap: 18px;
    grid-template-columns: minmax(0, 1fr);
`;

export const Pane = styled.section`
    backdrop-filter: blur(100px);
    background: rgba(255, 255, 255, 0.1);
    border: 1px solid rgba(255, 255, 255, 0.2);
    border-radius: 16px;
    display: grid;
    gap: 12px;
    min-width: 0;
    padding: 14px;
`;

export const PaneHead = styled.div`
    align-items: center;
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
    justify-content: space-between;

    h2 {
        font-family: 'Roboto Condensed', sans-serif;
        font-size: 20px;
        font-weight: 700;
        letter-spacing: 0.04em;
        line-height: 1.2;
        margin: 0;
        text-transform: uppercase;
    }
`;

export const PaneActions = styled.div`
    align-items: center;
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
`;

export const Hint = styled.p`
    color: rgba(255, 255, 255, 0.62);
    font-size: 12px;
    font-weight: 500;
    line-height: 1.45;
    margin: 0;
`;

export const Scans = styled.div`
    display: grid;
    gap: 16px;
`;

export const ScanBlock = styled.div`
    display: grid;
    gap: 8px;
`;

export const ScanMeta = styled.div`
    align-items: center;
    color: rgba(255, 255, 255, 0.7);
    display: flex;
    flex-wrap: wrap;
    font-size: 12px;
    font-weight: 500;
    gap: 8px;
    justify-content: space-between;

    b {
        font-weight: 600;
        min-width: 0;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }
`;

export const Stage = styled.div`
    line-height: 0;
    position: relative;

    img {
        border-radius: 4px;
        display: block;
        height: auto;
        user-select: none;
        width: 100%;
    }
`;

export const Overlay = styled.svg`
    cursor: crosshair;
    height: 100%;
    inset: 0;
    position: absolute;
    touch-action: none;
    width: 100%;

    polygon.box {
        cursor: pointer;
        fill: rgba(255, 122, 69, 0.16);
        stroke: #ff7a45;
        stroke-width: 2.5;
        vector-effect: non-scaling-stroke;
    }

    polygon.box.off {
        fill: transparent;
        opacity: 0.6;
        stroke-dasharray: 6 5;
    }

    polygon.box.sel {
        cursor: move;
        fill: rgba(142, 182, 255, 0.18);
        stroke: #8eb6ff;
        stroke-width: 3;
    }

    polygon.margin {
        fill: none;
        pointer-events: none;
        stroke: #ffb088;
        stroke-dasharray: 4 4;
        stroke-width: 1.5;
        vector-effect: non-scaling-stroke;
    }

    text {
        fill: #ff7a45;
        font-family: 'Inter', sans-serif;
        font-weight: 600;
        paint-order: stroke;
        pointer-events: none;
        stroke: rgba(0, 0, 0, 0.72);
    }

    line.stem {
        pointer-events: none;
        stroke: #8eb6ff;
        stroke-width: 2;
        vector-effect: non-scaling-stroke;
    }

    .handle {
        fill: #ffffff;
        stroke: #8eb6ff;
        stroke-width: 2;
        vector-effect: non-scaling-stroke;
    }

    .handle.rot {
        cursor: grab;
    }

    .handle.corner {
        cursor: nwse-resize;
    }

    rect.draft {
        fill: none;
        stroke: #8eb6ff;
        stroke-dasharray: 5 4;
        stroke-width: 2;
        vector-effect: non-scaling-stroke;
    }
`;

export const Status = styled.p`
    color: ${({ $kind }) => ($kind === 'ok' ? '#7ddea6' : $kind === 'err' ? '#ffb15a' : 'rgba(255, 255, 255, 0.62)')};
    font-size: 12px;
    font-weight: 500;
    line-height: 1.4;
    margin: 0;
    min-height: 1.2em;
`;

export const PhotoGrid = styled.div`
    display: grid;
    gap: 14px;
    grid-template-columns: repeat(auto-fill, minmax(min(180px, 100%), 1fr));
`;

export const Photo = styled.article`
    display: grid;
    gap: 8px;
    min-width: 0;
`;

export const PhotoFrame = styled.div`
    aspect-ratio: ${({ $square }) => ($square ? '1 / 1' : '5 / 7')};
    background: repeating-conic-gradient(rgba(255, 255, 255, 0.14) 0 25%, transparent 0 50%) 0 0 / 16px 16px;
    border: 1px solid rgba(255, 255, 255, 0.2);
    border-radius: 6px;
    min-width: 0;
    overflow: hidden;
    position: relative;
    width: 100%;

    canvas {
        display: block;
        height: 100%;
        object-fit: contain;
        width: 100%;
    }

    &:hover canvas,
    &:focus-within canvas {
        filter: blur(3px) brightness(0.55);
    }
`;

export const ViewButton = styled.button`
    align-items: center;
    background: transparent;
    border: 0;
    color: #ffffff;
    cursor: zoom-in;
    display: flex;
    flex-direction: column;
    font-size: 12px;
    font-weight: 600;
    gap: 6px;
    inset: 0;
    justify-content: center;
    letter-spacing: 0.14em;
    opacity: 0;
    position: absolute;
    transition: opacity 0.2s ease;

    svg {
        height: 28px;
        width: 28px;
    }

    ${PhotoFrame}:hover &,
    &:focus-visible {
        background: rgba(8, 11, 16, 0.28);
        opacity: 1;
    }
`;

export const PhotoRow = styled.div`
    align-items: center;
    display: flex;
    gap: 6px;
    justify-content: space-between;
    min-width: 0;
`;

export const PhotoName = styled.span`
    color: rgba(255, 255, 255, 0.72);
    font-size: 12px;
    font-weight: 500;
    min-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
`;

export const Dims = styled.span`
    color: rgba(255, 255, 255, 0.55);
    font-size: 11px;
    font-variant-numeric: tabular-nums;
    font-weight: 500;
`;

export const Tag = styled.span`
    background: ${({ $warn }) => ($warn ? 'rgba(229, 162, 58, 0.2)' : 'rgba(142, 182, 255, 0.18)')};
    border-radius: 99px;
    color: ${({ $warn }) => ($warn ? '#ffd18a' : '#c5d6ff')};
    font-size: 11px;
    font-weight: 600;
    padding: 2px 6px;
`;

export const Empty = styled.div`
    color: rgba(255, 255, 255, 0.62);
    font-size: 13px;
    font-weight: 500;
    padding: 28px 8px;
    text-align: center;
`;

export const Check = styled.label`
    align-items: center;
    cursor: pointer;
    display: inline-flex;
    font-size: 13px;
    font-weight: 500;
    gap: 6px;
    user-select: none;

    input[type='checkbox'] {
        accent-color: #ffffff;
        height: 16px;
        margin: 0;
        width: 16px;
    }

    input[type='color'] {
        background: transparent;
        border: 1px solid rgba(255, 255, 255, 0.28);
        border-radius: 4px;
        cursor: pointer;
        height: 28px;
        padding: 2px;
        width: 32px;
    }

    input[type='color']:disabled {
        cursor: not-allowed;
        opacity: 0.4;
    }
`;

export const Btn = styled.button`
    align-items: center;
    background: rgba(255, 255, 255, 0.1);
    border: 1px solid rgba(255, 255, 255, 0.22);
    border-radius: 4px;
    color: #ffffff;
    cursor: pointer;
    display: inline-flex;
    font-family: 'Inter', sans-serif;
    font-size: 12px;
    font-weight: 600;
    gap: 6px;
    height: 40px;
    padding: 0 14px;
    transition: background 0.2s ease, transform 0.2s ease;

    &:hover:not(:disabled) {
        background: rgba(255, 255, 255, 0.2);
        transform: scale(0.985);
    }

    &:disabled {
        cursor: default;
        opacity: 0.45;
    }

    &:focus-visible {
        outline: 2px solid #ffffff;
        outline-offset: 2px;
    }

    ${({ $size }) => $size === 'sm' && `
        height: 32px;
        padding: 0 10px;
    `}

    ${({ $icon }) => $icon && `
        height: 24px;
        justify-content: center;
        padding: 0;
        width: 24px;
    `}

    ${({ $variant }) => $variant === 'go' && `
        background: rgba(76, 194, 127, 0.28);
        border-color: rgba(125, 222, 166, 0.7);
    `}

    ${({ $variant }) => $variant === 'danger' && `
        color: #ffb0a1;
    `}
`;

export const ToolRow = styled.span`
    display: inline-flex;
    gap: 4px;
`;

export const EditDock = styled.div`
    background: rgba(16, 18, 24, 0.72);
    border: 1px solid rgba(255, 255, 255, 0.22);
    border-radius: 12px;
    bottom: calc(16px + env(safe-area-inset-bottom, 0px));
    box-shadow: 0 12px 32px rgba(0, 0, 0, 0.35);
    display: grid;
    gap: 8px;
    left: 50%;
    padding: 12px 16px;
    position: fixed;
    transform: translateX(-50%);
    width: min(820px, calc(100% - 32px));
    z-index: 30;
    backdrop-filter: blur(16px);
`;

export const EditRow = styled.div`
    align-items: center;
    display: flex;
    flex-wrap: wrap;
    gap: 8px 14px;
`;

export const Tilt = styled.span`
    align-items: center;
    display: inline-flex;
    gap: 6px;

    input[type='range'] {
        accent-color: #ffffff;
        width: 130px;
    }
`;

export const EditActions = styled.span`
    display: inline-flex;
    flex-wrap: wrap;
    gap: 6px;
    margin-left: auto;
`;

export const Viewer = styled.div`
    align-items: center;
    background: rgba(8, 11, 16, 0.78);
    display: grid;
    inset: 0;
    justify-items: center;
    padding: 16px;
    position: fixed;
    z-index: 50;
`;

export const ViewerBox = styled.div`
    background: rgba(16, 18, 24, 0.88);
    border: 1px solid rgba(255, 255, 255, 0.2);
    border-radius: 12px;
    display: grid;
    gap: 10px;
    max-height: 100%;
    max-width: min(1100px, 100%);
    min-width: 0;
    padding: 12px;
    width: 100%;
`;

export const ViewerHead = styled.div`
    align-items: center;
    display: flex;
    gap: 8px;
    justify-content: space-between;
`;

export const ViewerTitle = styled.div`
    align-items: baseline;
    display: flex;
    flex-wrap: wrap;
    font-size: 13px;
    font-weight: 500;
    gap: 4px 10px;
    min-width: 0;
`;

export const ViewerBody = styled.div`
    align-items: center;
    display: flex;
    gap: 8px;
    min-width: 0;
`;

export const ViewerStage = styled.div`
    display: grid;
    flex: 1;
    justify-items: center;
    min-width: 0;

    canvas {
        background: repeating-conic-gradient(rgba(255, 255, 255, 0.14) 0 25%, transparent 0 50%) 0 0 / 16px 16px;
        border-radius: 4px;
        display: block;
        height: auto;
        max-height: calc(100vh - 160px);
        max-width: 100%;
        width: auto;
    }
`;

export const NavBtn = styled.button`
    background: rgba(255, 255, 255, 0.08);
    border: 1px solid rgba(255, 255, 255, 0.22);
    border-radius: 8px;
    color: #ffffff;
    cursor: pointer;
    flex: none;
    font-size: 26px;
    height: 56px;
    line-height: 1;
    width: 36px;

    &:disabled {
        cursor: default;
        opacity: 0.3;
    }

    &:hover:not(:disabled) {
        border-color: rgba(255, 255, 255, 0.55);
    }
`;
